<div class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.title }}</span>
    <button class="icon-button icon-close" (click)="goToHyperlinks()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "hyperlink.item.url" | translate }}</label>
              <a [href]="item.urlLink" target="_blank">Link</a>
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell label-span">
                <label>{{ "hyperlink.item.urlDe" | translate }}</label>
                <a [href]="item.urlLinkDe" target="_blank">Link</a>
              </div>
            }
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "hyperlink.item.title" | translate }}</label>
              <span>{{ item.title }}</span>
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell label-span">
                <label>{{ "hyperlink.item.titleDe" | translate }}</label>
                <span>{{ item.titleDe }}</span>
              </div>
            }
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "hyperlink.item.description" | translate }}</label>
              <span>{{ item.description }}</span>
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell label-span">
                <label>{{ "hyperlink.item.descriptionDe" | translate }}</label>
                <span>{{ item.descriptionDe }}</span>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
